export default __webpack_public_path__ + "static/media/general_knowledge.5ba6a66a.jpg";